const { userList } = require("constants/user");

const initialState = {
  userList: {},
};

const user = (state = initialState, action) => {
  switch (action.type) {
    case userList:
      return { ...state, userList: action.payload };

    default:
      return state;
  }
};
export default user;
